<template>
  <div>
    <svg
      width="48"
      height="33"
      viewBox="0 0 48 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.5"
        width="48"
        height="32"
        rx="4"
        fill="#224DBA"
      />
      <path
        d="M14.5665 21.3973H11.8318L9.78117 13.3973C9.68384 13.0293 9.47717 12.704 9.17317 12.5506C8.38526 12.1432 7.54008 11.8577 6.6665 11.704V11.396H11.0718C11.6798 11.396 12.1358 11.8586 12.2118 12.396L13.2758 18.1666L16.0092 11.396H18.6678L14.5665 21.396V21.3973ZM20.1878 21.3973H17.6052L19.7332 11.396H22.3158L20.1892 21.396L20.1878 21.3973ZM25.6558 14.168C25.7318 13.6293 26.1878 13.3213 26.7198 13.3213C27.5819 13.2423 28.4491 13.4019 29.2265 13.7826L29.6825 11.6293C28.9337 11.3282 28.1349 11.1713 27.3278 11.1666C24.8212 11.1666 22.9972 12.552 22.9972 14.4746C22.9972 15.9373 24.2892 16.7053 25.2012 17.168C26.1878 17.6293 26.5678 17.9373 26.4918 18.3986C26.4918 19.0906 25.7318 19.3986 24.9732 19.3986C24.0529 19.387 23.1461 19.1769 22.3145 18.7826L21.8585 20.9373C22.7507 21.3004 23.7059 21.4834 24.6692 21.476C27.4798 21.552 29.2265 20.168 29.2265 18.0906C29.2265 15.4746 25.6558 15.3213 25.6558 14.168ZM38.2652 21.3973L36.2132 11.396H34.0105C33.7756 11.3994 33.5475 11.4751 33.3571 11.6128C33.1668 11.7504 33.0234 11.9433 32.9465 12.1653L29.1492 21.3973H31.8078L32.3385 19.936H35.6052L35.9092 21.3973H38.2638H38.2652ZM34.3918 14.088L35.1518 17.8573H33.0238L34.3918 14.088Z"
        fill="white"
      />
    </svg>
  </div>
</template>

<script>
export default {
    name: 'VisaIcon',
}
</script>